import { render, staticRenderFns } from "./order-list-detail.vue?vue&type=template&id=70f5dc7a&scoped=true"
import script from "./order-list-detail.vue?vue&type=script&lang=js"
export * from "./order-list-detail.vue?vue&type=script&lang=js"
import style0 from "./order-list-detail.vue?vue&type=style&index=0&id=70f5dc7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f5dc7a",
  null
  
)

export default component.exports